var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTestIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.620117,
    width: 51.3803,
    height: 48,
    rx: 6,
    fill: "url(#paint0_linear_1126_5512460)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3281 14.1252C31.6017 13.8516 31.9265 13.6345 32.284 13.4865C32.6414 13.3384 33.0245 13.2622 33.4115 13.2622C33.7984 13.2622 34.1815 13.3384 34.5389 13.4865C34.8964 13.6345 35.2212 13.8516 35.4948 14.1252C35.7684 14.3987 35.9854 14.7235 36.1335 15.081C36.2815 15.4385 36.3577 15.8216 36.3577 16.2085C36.3577 16.5954 36.2815 16.9785 36.1335 17.336C35.9854 17.6934 35.7684 18.0182 35.4948 18.2918L21.4323 32.3543L15.7031 33.9168L17.2656 28.1877L31.3281 14.1252Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1126_5512460",
    x1: 26.3103,
    y1: 0,
    x2: 26.3103,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9977F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E42E5"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTestIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TestIcon.00b68c95.svg";
export { ForwardRef as ReactComponent };